// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3JRYT","errors":"Errors_errors__2wzoG"};